<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header mb-4">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t("adiantamento") }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("despesas")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'des-adiantamentos',
                                            })
                                        "
                                        >{{ $t("adiantamentos") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t("adiantamento-detalhe")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'des-adiantamentos' })"
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="situacao == 'ABERTO' && permissao.delete"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="promptForDelete()"
                        >
                            {{ $t("excluir") }}
                        </button>
                    </div>
                </div>

                <div class="box">
                    <div class="card-title-custom mb-2">
                        <p class="is-size-3">
                            {{ $t("dados-do-adiantamento") }}
                            <b-tag
                                :type="isStatusButtonType(situacao)"
                                size="is-large"
                                v-if="situacao != null || situacao != ''"
                            >
                                {{ situacaoTag(situacao) }}
                            </b-tag>
                        </p>
                    </div>
                    <b-table :data="data">
                        <b-table-column
                            v-for="(f, i) in columns"
                            :key="i"
                            :field="f.field"
                            v-slot="props"
                            :width="f.width ? f.width + 'px' : null"
                        >
                            <div
                                v-if="f.field == 'titulo'"
                                class="colums-mobile"
                            >
                                <strong>{{ props.row.titulo }}:</strong>
                            </div>

                            <div v-if="f.field == 'valor'">
                                {{ props.row.valor }}
                            </div>

                            <div
                                v-if="
                                    props.row.subtitulo &&
                                    f.field == 'subtitulo'
                                "
                                class="colums-mobile"
                            >
                                <strong>{{ props.row.subtitulo }}:</strong>
                            </div>

                            <div
                                v-if="
                                    props.row.subtitulo && f.field == 'subvalor'
                                "
                            >
                                {{ props.row.subvalor }}
                            </div>
                        </b-table-column>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdiantamentoService from "@/services/despesas/AdiantamentoService";

export default {
    data() {
        return {
            colaborador: {
                titulo: this.$t("colaborador"),
                valor: null,
                subtitulo: this.$t("valor"),
                subvalor: null,
            },
            cadastro: {
                titulo: this.$t("cadastro"),
                valor: null,
                subtitulo: this.$t("data-hora"),
                subvalor: null,
            },
            exclusao: {
                titulo: this.$t("exclusao"),
                valor: null,
                subtitulo: this.$t("data-hora"),
                subvalor: null,
            },
            motivoExclusao: {
                titulo: this.$t("motivo-exclusao"),
                valor: null,
            },
            data: [],
            observacao: {
                titulo: this.$t("observacao"),
                valor: null,
                subtitulo: this.$t("empresa"),
                subvalor: null,
            },
            situacao: "",
            idadiantamento: null,
            columns: [
                { field: "titulo", width: 160 },
                { field: "valor" },
                { field: "subtitulo", width: 130 },
                { field: "subvalor" },
            ],
            service: new AdiantamentoService(this.$http, this.$router),
            isLoading: false,
            delete: null,
            permissao: {},
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "despesas",
            "cadastros",
            "des-adiantamentos"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "adiantamentos" },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
            } else {
                this.$router.push({ name: "des-adiantamentos" });
            }
        }
    },
    methods: {
        situacaoTag(situacao) {
            if (situacao != "" && situacao != null) {
                situacao = situacao.toLowerCase();
                return this.$t(situacao);
            } else {
                return null;
            }
        },
        isStatusButtonType(status) {
            if (status == "ABERTO") return "is-danger";
            else if (status == "FECHADO") return "is-success";
            else if (status == "EXCLUIDO") return "is-warning";
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.colaborador.valor = value.content.usuario.nome;
                    this.colaborador.subvalor = this.getDecimal(value.content.valor, null, true);
                    this.data.push(this.colaborador);

                    this.cadastro.valor = value.content.usuarioadminc.nome;
                    this.cadastro.subvalor = this.$moment(
                        value.content.datahorainc
                    ).format("DD/MM/YYYY H:mm:ss");
                    this.data.push(this.cadastro);

                    if (value.content.datahoradel) {
                        this.exclusao.valor = value.content.usuarioadmdel.nome;
                        this.exclusao.subvalor = this.$moment(
                            value.content.datahoradel
                        ).format("DD/MM/YYYY H:mm:ss");
                        this.exclusao.obsmotivodel = value.content.obsmotivodel;
                        this.data.push(this.exclusao);
                    }

                    this.observacao.valor = value.content.obsgeral;
                    this.observacao.subvalor = value.content.empresa.nome;
                    this.data.push(this.observacao);

                    if (value.content.obsmotivodel != null) {
                        this.motivoExclusao.valor = value.content.obsmotivodel;
                        this.data.push(this.motivoExclusao);
                    }

                    this.idadiantamento = value.content.idadiantamento;
                    this.situacao = value.content.tipo;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        mapItems(body) {
            let list = body.content.map((m) => {
                return {
                    id: m.id,
                    descricao: m.descricao,
                };
            });
            return list;
        },
        promptForDelete() {
            this.$root.confirm({
                message: this.$t("msg-confirmacao-desativacao-n", 
                    { n: this.colaborador.valor }
                ),
                onConfirm: this.promptForMotivoDelete,
                onCancel: this.removePrompt(),
            });
        },
        promptForMotivoDelete() {
            this.$root.prompt({
                message: this.$t("msg-confirmacao-motivo-n"),
                confirmText: this.$t("confirmar"),
                onConfirm: this.deletarAdiantamento,
                cancelText: this.$t("cancelar"),
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        deletarAdiantamento(motivo) {
            this.isLoading = true;
            this.service
                .deleteAdiantamentoById(this.idadiantamento, motivo)
                .then((_) => {
                    this.$root.showMessage("success", "msg-success-desativar");
                    this.carregarDados(this.idadiantamento);
                })
                .catch((e) => {
                    console.error("Erro ao remover acerto.", e);
                    this.$root.showMessage(
                        "error",
                        "msg-problema-realizar-acao"
                    );
                })
                .finally((_) => {
                    this.data = [];
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;
    }
    .card-title-custom {
        text-align: center;
    }
    .b-table .table {
        border-collapse: collapse;
    }
    @media screen and (max-width: 768px) {
        .b-table .table {
            border-collapse: separate;
        }
        .colums-mobile {
            width: 100% !important;
        }
        .b-table
            .table-wrapper.has-mobile-cards
            tr:not(.detail):not(.is-empty):not(.table-footer)
            td {
            justify-content: left;
            text-align: left;
        }
        .b-table .table-wrapper.has-mobile-cards .table-footer {
            margin-top: 15px;
            padding-left: 5px;
        }
    }
}
</style>
